var exports = {
  "V": "Picture__H9T5wr",
  "_": "Image__XhVUxm",
};

module.exports = exports;
